import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'removeBackslash',
    standalone: true
})
export class removeBackslash implements PipeTransform {

  transform(value: string | null | undefined): string {
    return value ? value.replace(/\\/g, '') : '';
  }
}

 